export type AdminDashboardPieData = {
  name: string;
  success: number;
  failed: number;
  amount: number;
}[];

export type AdminDashboardStatsData = {
  current: {
    totalTransactions: number;
    totalAmount: number;
    totalSuccess: number;
    totalFailed: number;
    totalActiveChannel: number;
  };
  previous: {
    totalTransactions: number;
    totalAmount: number;
    totalSuccess: number;
    totalFailed: number;
    totalActiveChannel: number;
  };
};

export type AdminDashboardBarData = {
  date: string;
  channels: {
    [key: string]: {
      volume: number;
      revenue: number;
    };
  };
}[];

export type AdminDashboardAreaData = {
  month: string;
  channels: {
    [key: string]: {
      success: number;
      failed: number;
    };
  };
}[];

export const ADMIN_DASHBOARD_ENDPOINT = "/admin/dashboard";
